import LandingNavbar from "@/components/landing/LandingNavbar";
import LandingFooter from "@/components/landing/LandingFooter";

const Refund = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <LandingNavbar />
      
      <main className="flex-1 container mx-auto px-4 pt-24 pb-12 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
          Cancellation and Refund Policy
        </h1>
        
        <div className="prose prose-lg dark:prose-invert max-w-none space-y-8">
          <p className="text-muted-foreground">
            Last updated: January 2025
          </p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              1. Cancellation Policy
            </h2>
            <p className="text-muted-foreground mb-4">
              We want you to be completely satisfied with StoryPlay. If you're not happy with your subscription, you may request a cancellation under the following conditions:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>
                <strong>48-Hour Window:</strong> Cancellation requests must be made within 48 hours (2 days) of your purchase date.
              </li>
              <li>
                <strong>No Usage Requirement:</strong> Your account must not have generated any stories during the 48-hour period following your purchase. If any stories have been created, the cancellation request will not be eligible for a refund.
              </li>
              <li>
                <strong>How to Cancel:</strong> To request a cancellation, please email us at <a href="mailto:support@storyplay.me" className="text-primary hover:underline">support@storyplay.me</a> with your account email and reason for cancellation.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              2. Refund Policy
            </h2>
            <p className="text-muted-foreground mb-4">
              Refunds are only processed for cancellation requests that meet the eligibility criteria outlined above.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>
                <strong>Processing Time:</strong> Once your cancellation is approved, refunds will be processed within 5-7 business days.
              </li>
              <li>
                <strong>Refund Method:</strong> Refunds will be issued to the original payment method used for the purchase.
              </li>
              <li>
                <strong>Full Refunds Only:</strong> Partial refunds are not available. Refunds are issued for the full subscription amount only.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              3. Non-Refundable Situations
            </h2>
            <p className="text-muted-foreground mb-4">
              Refunds will not be provided in the following cases:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Requests made after the 48-hour cancellation window has passed.</li>
              <li>Accounts where any stories have been generated after purchase.</li>
              <li>Free trial conversions (as no payment was made during the trial period).</li>
              <li>Subscriptions that have been active for more than one billing cycle.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              4. Subscription Cancellation vs. Refund
            </h2>
            <p className="text-muted-foreground mb-4">
              Please note that cancelling your subscription is different from requesting a refund:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>
                <strong>Subscription Cancellation:</strong> When you cancel your subscription through your Account settings, your subscription will not renew at the end of the current billing period. You will retain access to your plan's features until the end of the paid period.
              </li>
              <li>
                <strong>Refund Request:</strong> A refund request (if eligible) results in the immediate termination of your subscription and the return of your payment.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              5. How to Request a Refund
            </h2>
            <p className="text-muted-foreground mb-4">
              To request a refund, please follow these steps:
            </p>
            <ol className="list-decimal pl-6 space-y-2 text-muted-foreground">
              <li>Send an email to <a href="mailto:support@storyplay.me" className="text-primary hover:underline">support@storyplay.me</a></li>
              <li>Include your registered account email address in the email.</li>
              <li>Briefly explain your reason for requesting a cancellation and refund.</li>
              <li>Our support team will review your request and respond within 24-48 hours.</li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              6. Contact Us
            </h2>
            <p className="text-muted-foreground">
              If you have any questions about our Cancellation and Refund Policy, please don't hesitate to reach out to us:
            </p>
            <p className="text-muted-foreground mt-4">
              <strong>Email:</strong>{" "}
              <a href="mailto:support@storyplay.me" className="text-primary hover:underline">
                support@storyplay.me
              </a>
            </p>
          </section>

          <section className="border-t border-border pt-8 mt-8">
            <p className="text-sm text-muted-foreground">
              This policy is subject to change. We recommend reviewing this page periodically for any updates. Your continued use of StoryPlay after any modifications indicates your acceptance of the updated policy.
            </p>
          </section>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
};

export default Refund;
